import { render, staticRenderFns } from "./ChatVideo.vue?vue&type=template&id=b8e5ad28&"
import script from "./ChatVideo.vue?vue&type=script&lang=js&"
export * from "./ChatVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports